export default {
  SET_NOTIFICATIONS (state, notifications) {
    state.notifications = notifications
  },
  MARK_NOTIFICATION_READ (state, notification) {
    notification.readAt = Date()
  },
  ADD_NOTIFICATION (state, notification) {
    state.notifications.unshift(notification)
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/notifications/store/mutations.js